<style>
@media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  }
}
</style>

<template>
  <v-row justify="center" align="center">
    <v-col xs="12" sm="10" md="8" lg="8" xl="7" class="pa-0">
      <v-stepper v-model="step" alt-labels>
        <v-stepper-header>
          <v-stepper-step
            :complete="step > 1"
            step="1"
          >
            {{ $t('search') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="2"
          >
            {{ $t('form_update_info') }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card
              flat
              class="full-width mb-5"
            >
              <div class="text-center">
                <v-text-field autofocus prepend-icon="fa-home fa-lg" name="assessment_no" :disabled="loading" :readonly="loading" v-model="assessment_no" :label="$t('assessment_no')" required type="text"></v-text-field>

                <v-btn color="primary" @click="onSearchAssessmentClicked()" :disabled="assessment_no.length === 0">
                  <v-icon class="pr-3">fa-search fa-lg</v-icon>
                  {{ $t('check') }}
                </v-btn>
                <br />
                <br />
                <br />
                <div v-if="assessment" class="text-left pa-4" style="border: 1px solid black;">
                  {{ $t('assessment_no') }}:  {{ assessment.assessment_no }}<br />
                  {{ $t('title_no') }}:  {{ assessment.current_title }}<br />
                  {{ $t('locality') }}: {{ assessment.locality }}<br />
                  {{ $t('paid_until') }}: {{ assessment.paid_until }}<br />
                  {{ $t('owner_name') }}: {{ hideText(assessment.name) }}<br />
                  {{ $t('ic_no') + " / " + $t('register_no') }}: {{ hideIC(assessment.icno_nocompany) }}<br />
                </div>
              </div>
            </v-card>

            <div class="text-right">
              <v-btn text @click="assessment_no = ''; assessment = null;">
                {{ $t('reset') }}
              </v-btn>

              <v-btn
                color="primary"
                :disabled="!assessment"
                @click="step = '2'"
              >
                {{ $t('continue') }}
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form ref="form" @submit.prevent="submitForm($event)">
              <v-card class="text-center" flat>
                <span class="title primary--text text--darken-2"><strong>{{ $t('form_update_info') }}</strong></span>
                <v-select prepend-icon="fa-ticket fa-lg" name="ticket_type" v-model="data.ticket_type" :label="$t('ticket_type')" :items="ticketTypes" :item-text="opt => opt.name" :item-value="opt => opt" :rules="[rules.required]" :disabled="loading" :readonly="loading"></v-select>
                <v-switch
                  v-model="subscribe"
                  :label="`${$t('subscribe_ebilling')}? ${subscribe ? $t('yes') : $t('no')}`"
                ></v-switch>
                <v-text-field prepend-icon="fa-envelope fa-lg" name="title" v-model="data.title" :label="$t('title')" required type="text" :rules="[validateRequired('title')]" readonly></v-text-field>
                <v-textarea prepend-icon="fa-file fa-lg" :label="$t('content')" v-model="data.body" name="body" type="text" :disabled="loading" :readonly="loading"></v-textarea><br>
                <span v-if="data.ticket_type && data.ticket_type.required_attachments" class="title primary--text text--darken-2"><strong>{{ $t('supporting_documents') }}<br v-if="$vuetify.breakpoint.xsOnly" /> ({{ $t("for_verification_purpose") }})</strong></span>
                <v-row v-if="data.ticket_type && data.ticket_type.required_attachments" wrap>
                  <v-col cols="12">
                    <v-file-input v-if="!isCordova" :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="photocopy_ic" type="file" v-model="photocopy_ic" :label="$t('photocopy_ic')" @change="handleFileUpload($event, 'photocopy_ic')" :clearable="false" @click:clear="photocopy_ic = data._attachments.photocopy_ic = null;" capture />
                    <span v-if="isCordova">{{ $t('photocopy_ic') }} :</span><br />
                    <v-btn color="primary" @click="startCamera('photocopy_ic')" v-if="isCordova && !photocopy_ic">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="photocopy_ic = data._attachments.photocopy_ic = null;" v-if="isCordova && photocopy_ic">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_ic.jpg
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input v-if="!isCordova && data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="sales_purchase_agreement" type="file" v-model="sales_purchase_agreement" :label="$t('sales_purchase_agreement')" @change="handleFileUpload($event, 'sales_purchase_agreement')" :clearable="false" @click:clear="sales_purchase_agreement = data._attachments.sales_purchase_agreement = null;" capture />
                    <span v-if="isCordova">{{ $t('sales_purchase_agreement') }} :</span><br />
                    <v-btn color="primary" @click="startCamera('sales_purchase_agreement')" v-if="isCordova && !photocopy_ic">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="photocopy_ic = data._attachments.photocopy_ic = null;" v-if="isCordova && photocopy_ic">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_ic.jpg
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input v-if="!isCordova" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="document_1" type="file" v-model="document_1" :label="`${$t('other_document')} 1`" @change="handleFileUpload($event, 'document_1')" :clearable="false" @click:clear="document_1 = data._attachments.document_1 = null;" capture />
                    <span v-if="isCordova">{{ $t('other_document') }} 1 :</span><br />
                    <v-btn color="primary" @click="startCamera('document_1')" v-if="isCordova && !document_1">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="document_1 = data._attachments.document_1 = null;" v-if="isCordova && document_1">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> document_1.jpg
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input v-if="!isCordova" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="document_2" type="file" v-model="document_2" :label="`${$t('other_document')} 2`" @change="handleFileUpload($event, 'document_2')" :clearable="false" @click:clear="document_2 = data._attachments.document_2 = null;" capture />
                    <span v-if="isCordova">{{ $t('other_document') }} 2 :</span><br />
                    <v-btn color="primary" @click="startCamera('document_2')" v-if="isCordova && !document_2">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="document_2 = data._attachments.document_2 = null;" v-if="isCordova && document_2">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> document_2.jpg
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
              <br>
              <v-divider />
              <br/>
              <v-card class="text-center" flat>
                <v-layout class="pa-3" column wrap>
                  <span class="title primary--text text--darken-2"><strong>{{ $t('contact_detail') }}</strong></span>
                    <v-text-field prepend-icon="fa-user-circle fa-lg" clearable v-model="data.customer_name" :label="$t('full_name')" name="full_name" required type="text" :disabled="loading" :readonly="loading" :rules="[validateRequired('full_name')]"></v-text-field>
                    <v-text-field class="pt-2" prepend-icon="fa-id-card fa-lg" clearable name="ic_num" :value="icFormat(data.customer_ic)" @input="data.customer_ic = $event" :counter="14" maxLength="14" :label="$t('ic_num')" required type="text" :disabled="loading" :readonly="loading" :rules="[validateRequired('ic_num'), rules.nricLength, rules.dateOfBirth]"></v-text-field>
                    <v-row wrap align="center" justify="center" class="text-center">
                      <v-col cols="12" sm="12" md="7" lg="7">
                        <v-text-field class="pt-2" maxLength="11" prepend-icon="fa-phone-square fa-lg" :label="$t('phone_no')" v-model="data.customer_phone" name="phone_no" type="tel" :disabled="verify.result || loading" :readonly="loading || verify.result" required :rules="[validateRequired('phone_no')]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="5" lg="5">
                        <v-btn color="primary" rounded outlined :disabled="currentTime > 0 || data.customer_phone.length < 10" @click="sendVerification" v-if="!verify.result">
                          {{ sent ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', { channel: 'SMS' }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row wrap align="center" justify="center" v-if="sent">
                      <v-col md="10" sm="12" cols="12">
                        <v-text-field prepend-icon="fa-code fa-lg" validate-on-blur :rules="[rules.required]" v-model="verify.input" :label="$t('verification_code')" name="code" required type="text" :disabled="verify.result"></v-text-field>
                      </v-col>
                      <v-col md="2" sm="12" cols="12">
                        <v-btn color="primary" rounded outlined :disabled="verify.input.length === 0 || verify.result" @click="verifyCode">
                          {{ $t("verify") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-text-field class="pt-2" prepend-icon="fa-envelope fa-lg" v-model="data.customer_email" :label="$t('email_address')" name="email_address" required type="email" :disabled="loading" :readonly="loading" :rules="[validateRequired('email_address')]"></v-text-field>
                </v-layout>
              </v-card>
              <br>

              <div class="text-right">
                <v-btn text @click="assessment_no = ''; assessment = null; step = '1'">
                  {{ $t('cancel') }}
                </v-btn>

                <v-btn color="primary" large rounded type="submit" :disabled="loading" :loading="loading">{{ $t('submit') }}</v-btn>
              </div>
            </v-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
    <canvas id="imageCanvas" class="d-none" />
  </v-row>
</template>

<script>
import axios from '../../axios'
import configuration from '../../configurations'
import { throttle } from 'lodash'
import { mapActions } from 'vuex'

const calculateAspectRatioFit = (
  srcWidth,
  srcHeight,
  maxWidth,
  maxHeight
) => {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  var rtnWidth = srcWidth * ratio
  var rtnHeight = srcHeight * ratio

  return { width: rtnWidth, height: rtnHeight }
}

const downscaleImage = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()

    fileReader.onload = event => {
      const arrayBuffer = event.target.result
      const blob = new Blob([arrayBuffer], { type: 'image/jpeg' })
      const objectUrl = URL.createObjectURL(blob)
      let canvas = document.getElementById('imageCanvas')
      let context = canvas.getContext('2d')
      let image = new Image()

      image.src = objectUrl
      image.onload = () => {
        const { width, height } = calculateAspectRatioFit(
          image.width,
          image.height,
          2048,
          1152
        )

        canvas.width = width
        canvas.height = height
        context.drawImage(image, 0, 0, width, height)
        const data = canvas.toDataURL('image/jpeg', 0.95)
        resolve(data)
      }
    }

    fileReader.onerror = () => {
      fileReader.abort()
      reject(fileReader.error)
    }

    fileReader.readAsArrayBuffer(file)
  })
}

export default {
  computed: {
    isCordova () {
      return window.hasOwnProperty('cordova')
    },
    selectedIC () {
      return this.data._attachments && this.data._attachments.photocopy_ic && this.data._attachments.photocopy_ic !== null
    },
    selectedDocument1 () {
      return this.data._attachments && this.data._attachments.document_1 && this.data._attachments.document_1 !== null
    },
    selectedDocument2 () {
      return this.data._attachments && this.data._attachments.document_2 && this.data._attachments.document_2 !== null
    },
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || this.$t('invalidDateOfBirth')) : true),
        required: value => !!value || this.$t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('invalidEmailFormat')
        },
        percentage: value => (Number(value) <= 100 && Number(value) >= 0) || this.$t('invalidPercentage'),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || this.$t('invalidNRICFormat')) : true)
      }
    }
  },
  data: () => ({
    assessment: null,
    data: {
      _id: '',
      _attachments: {},
      body: '',
      customer_name: '',
      customer_ic: '',
      customer_phone: '',
      customer_email: '',
      ticket_type: null,
      status: 'new',
      title: ''
    },
    subscribe: true,
    step: '1',
    assessment_no: '',
    sales_purchase_agreement: null,
    photocopy_ic: null,
    document_1: null,
    document_2: null,
    loading: false,
    currentTime: 0,
    ticketTypes: [],
    verify: {
      code: null,
      input: '',
      result: false
    },
    sent: false,
    timer: null,
    cameraOption: {
      quality: 50,
      destinationType: window.Camera ? Camera.DestinationType.DATA_URL : null,
      encodingType: window.Camera ? Camera.EncodingType.JPEG : null,
      mediaType: window.Camera ? Camera.MediaType.PICTURE : null,
      sourceType: window.Camera ? Camera.PictureSourceType.CAMERA : null,
      allowEdit: false,
      correctOrientation: true
    }
  }),
  beforeMount: async function () {
    this.$store.commit('loading/setPageLoading', { loading: false })
    const user = await this.$store.dispatch('auth/session')
    if (user.userCtx.name && user.userCtx.name.length > 0 && !user.userCtx.roles.includes('_admin')) {
      this.verify.result = true
      this.data = Object.assign({}, this.data, { customer_name: user.userCtx.full_name || '', customer_phone: user.userCtx.phone || '', customer_email: user.userCtx.name || '', customer_ic: user.userCtx.ic_num || '' })
    }
    const { data } = await axios({
      url: `${configuration.WORKER}/tickets/find`,
      method: 'POST',
      data: {
        selector: {
          _id: { $eq: 'CSTT-UDCT' },
          type: { $eq: 'ticket-type' },
          status: { $eq: 'active' }
        },
        use_index: 'indexes/ticket-type'
      }
    })
    this.ticketTypes = data.docs.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    this.data.ticket_type = this.ticketTypes[0]
    this.data.title = this.data.ticket_type.name

    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.data.geolocation = geolocation
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })
  },
  methods: {
    ...mapActions(['sendSMS']),
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
      }
    },
    hideIC (text) {
      if (!text) return ''
      let hiddenText = ''
      if (text.length !== 0) {
        for (let i = 0; i < text.length; i++) {
          if (i < text.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += text[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      if (!text) return ''
      let hiddenText = ''
      for (let i = 0; i < text.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += text[i]
        }
      }
      return hiddenText
    },
    async onSearchAssessmentClicked () {
      this.loading = true
      try {
        const assessment = await this.$store.dispatch('tradingForm/searchData', this.assessment_no)
        if (assessment && assessment.assessment_no) {
          this.assessment = {
            assessment_no: assessment.assessment_no,
            current_title: assessment.current_title,
            locality: assessment.locality,
            paid_until: assessment.paid_until,
            name: assessment.name,
            icno_nocompany: assessment.icno_nocompany
          }
        } else {
          this.assessment = null
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    sendVerification: throttle(async function () {
      this.currentTime = 180
      this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(this.countdown, 1)
      this.sent = true
      await this.sendSMS({
        contact: this.data.customer_phone.replace(/\s/g, ''),
        message: `Your verification code is ${this.verify.code} for customer support ticket submission. Expires in 3 mins. Date: ${new Date().toLocaleString()}`
      })
    }, 1000),
    verifyCode () {
      if (this.verify.code === this.verify.input) {
        this.verify.result = true
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        return
      }
      this.verify.result = false
      this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: this.$t('invalid_code'), visible: true})
    },
    startCamera: throttle(function (field) {
      const onSuccess = imageData => {
        this[field] = this.data._attachments[field] = {
          content_type: 'image/jpeg',
          data: imageData
        }
      }
      const onFail = message => {
        console.error(message) // eslint-disable-line
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message, visible: true})
      }
      navigator.camera.getPicture(onSuccess, onFail, this.cameraOption)
    }, 1000),
    async handleFileSelect (files) {
      let data = null
      let isMultiple = Array.isArray(files)

      if (typeof files === 'undefined') {
        return
      }

      try {
        if (isMultiple) {
          data = []
          for (const file of files) {
            if (file instanceof File) {
              data.push(await downscaleImage(file))
            }
          }
        } else {
          if (files instanceof File) {
            data = await downscaleImage(files)
          }
        }

        return data
      } catch (error) {
        console.error(error)
      }
    },
    async handleFileUpload (file, field) {
      const result = await this.handleFileSelect(file)
      if (!result) return
      this.data._attachments[field] = {
        content_type: result.split(';')[0].replace('data:', ''),
        data: result.split(',')[result.split(',').length - 1]
      }
    },
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    validateRequired (translationKey) {
      const message = this.$t('validate_required', {
        field: this.$t(translationKey.toLowerCase())
      })
      return value => !!value || value === 0 || message
    },
    submitForm: throttle(async function ($event) {
      this.loading = true
      const result = this.$refs.form.validate()
      if (!result) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('incomplete_form'),
          visible: true
        })
        return
      }
      if (!this.verify.result) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('phone_is_not_verify'),
          visible: true
        })
        return
      }
      try {
        this.data.title = this.data.title.trim().toUpperCase()
        this.data.body = this.data.body.trim().toUpperCase()
        this.data.customer_name = this.data.customer_name.trim().toUpperCase()
        this.data.customer_phone = this.data.customer_phone.replace(/\s/g, '')
        this.data.customer_email = this.data.customer_email.replace(/\s/g, '')
        this.data.channel = `e-Services`
        if (!this.data.body || this.data.body.length === 0) this.data.body = '-'
        const response = await axios({
          url: `${configuration.WORKER}/tickets`,
          method: 'POST',
          data: this.data
        })
        await axios({
          url: `${configuration.WORKER}/query`,
          method: 'POST',
          data: {
            url: btoa('/ebilling'),
            payload: {
              channel: 'e-Services',
              assessment: this.assessment,
              customer_name: this.data.customer_name,
              customer_ic: this.data.customer_ic,
              customer_phone: this.data.customer_phone,
              customer_email: this.data.customer_email,
              ticket_reference_number: response.data.id,
              ebilling_subscription: this.subscribe,
              type: 'ebilling'
            }
          }
        })
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: this.$t('submit_successful'),
          visible: true
        })
        this.$router.push(`/ticket/detail/${response.data.id}`)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: error.message || error,
          visible: true
        })
      } finally {
        this.loading = false
      }
    }, 500)
  }
}
</script>
